var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "600" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _vm.event.EventTypeID == 1
        ? _c("crm-edit-message", { attrs: { value: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 2
        ? _c("crm-edit-call", {
            attrs: { contact: _vm.contact, value: _vm.event },
          })
        : _vm._e(),
      _vm.event.EventTypeID == 3
        ? _c("crm-edit-email", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 4
        ? _c("crm-edit-appointment", {
            attrs: { event: _vm.event },
            on: {
              "toggle-calendar": function ($event) {
                _vm.addOnCalendar = $event
              },
            },
          })
        : _vm._e(),
      _vm.event.EventTypeID == 5
        ? _c("crm-edit-close", { attrs: { event: _vm.event } })
        : _vm._e(),
      _vm.event.EventTypeID == 8
        ? _c("crm-edit-file", { attrs: { value: _vm.event } })
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.preSave()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditEvent != null } },
        [
          _vm.toEditEvent != null
            ? _c("app-calendar-event-edit", {
                attrs: { "max-width": "480", event: _vm.toEditEvent },
                on: {
                  close: function ($event) {
                    _vm.save(),
                      (_vm.addCalendarEvent = false),
                      (_vm.toEditEvent = null)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }